import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const ExternalMount = styled.div`
  position: absolute;
  background-color: red;
  top: 10000;
  left: 10000;
`;

export const ValueMessage = styled.div<{ left: number; top: number; sideLength: number }>`
  position: absolute;
  z-index: 3;
  top: ${({ top }) => `${top}px`};
  left: ${({ left }) => `${left}px`};
  width: ${({ sideLength }) => `${sideLength}px`};
  height: ${({ sideLength }) => `${sideLength}px`};
  display: flex;
  justify-content: center;
  align-items: center;
`;
